import { combineReducers } from 'redux';
import flash from './Flash';
import loader from './Loader';
import authentication from './Authentication';
import overview from './Overview';
import onboarding from './Onboarding';
import dashboard from './Dashboard';
import dialog from './Dialog';
import bottomBar from './BottomBar';
import dashboardFreelancer from './DashboardFreelancer';
import freelancer from './FreelancerOnboarding';
import payment from './Payment';
import projectView from './ProjectView';
import notification from './Notification';
import wizardFlow from './OnboardingRedesign';

export const combinedStore = combineReducers({
  flash,
  loader,
  authentication,
  overview,
  onboarding,
  dashboard,
  dialog,
  bottomBar,
  dashboardFreelancer,
  freelancer,
  payment,
  projectView,
  notification,
  wizardFlow,
});



// WEBPACK FOOTER //
// ./src/store/reducers/index.js